
import draggable from 'vuedraggable';
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import NevronImageField from "@/components/NevronImageField.vue";
import NevronFileField from "@/components/NevronFileField.vue";
import stores from "@/stores";
import NevronInput from "@/components/NevronInput.vue";
import NevronTextbox from "@/components/NevronTextbox.vue";
import {SweetModal} from 'sweet-modal-vue';
import {videoExtensions} from "@/helpers/files";

@Component({
  components: {
    NevronTextbox,
    NevronInput,
    NevronImageField,
    NevronFileField,
    draggable,
    SweetModal
  },
})
export default class WelcomeScreenElements extends Vue {
  stores = stores;

  @Prop({ required: true })
  welcomeScreen!: IWelcomeScreen;

  elements: IWelcomeScreenElement[] = [];

  videoExtensions = videoExtensions;

  mounted() {
    this.loadInitialElements();
  }

  @Watch('elements')
  onElementsChange() {
    this.$emit('change', this.elements);
  }

  @Watch('welcomeScreen.id')
  onWelcomeScreenChange() {
    this.loadInitialElements();
  }

  loadInitialElements() {
    this.elements = this.welcomeScreen.elements || [];
  }

  addElement() {
    this.elements.push({
      id: null,
      welcomeScreenId: this.welcomeScreen.id!,
      type: null,
      title: '',
      sort: this.elements.length + 1,
      description: '',
      guestNameAfterText: false,
      videoId: null,
      video: null,
      backgroundImageId: null,
      backgroundImage: null,
      signatureId: null,
      signature: null,
      audioMulticast: '',
      skipVideo: false,
      showActionButton: false,
      actionButtonText: '',
      showPressOkHint: false,
      stopAudioOnClose: false
    } as IWelcomeScreenElement);
  }

  removeElement(index: number) {
    this.elements.splice(index, 1);
  }

  copyElement(index: number) {
    const elementToCopy = this.elements[index];
    const newElement = JSON.parse(JSON.stringify(elementToCopy));
    newElement.id = null;
    this.elements.push(newElement);
  }

  updateElementOrder() {
    this.elements.forEach((element, index) => {
      element.sort = index + 1;
    });
  }

  selectBackgroundImage(index: number, image?: IMediaItem) {
    this.elements[index].backgroundImageId = image?.id || null;
    this.elements[index].backgroundImage = image || null;
  }

  selectSignatureImage(index: number, image?: IMediaItem) {
    this.elements[index].signatureId = image?.id || null;
    this.elements[index].signature = image || null;
  }

  selectVideo(index: number, video?: IMediaItem) {
    this.elements[index].videoId = video?.id || null;
    this.elements[index].video = video || null;
  }
};
